import React, { Component } from 'react';
const swea = require('swea');
const i18n = swea.i18n;
const withStyles = swea.withStyles;
import s from './ModelContextMenu.scss'

/**
 * A context menu for the model placement.
 *
 * @class
 * @extends { React.Component }
 * @memberOf react.components.contextmenus
 * @param { string } thumb The model thumbnail image path.
 * @param { string } name The model name.
 * @param { string } comment (optional) Smaller comment text.
 */
class ModelContextMenu extends Component {
  /**
   * @param props
   * @public
   */
  constructor(props) {
    super(props);
    /**
     * The initial component state.
     */
    this.state = {
      thumb: props.thumb,
      name: props.name,
      comment: props.comment
    };
  }
  
  /**
   * Executed on state change.
   */
  render() {
    let commentRow = undefined;
    if (this.state.comment) {
      commentRow = (
        <tr>
          <td><span className={s.comment}>({this.state.comment})</span></td>
        </tr>
      );
    }
    
    return (
      <span className={s.root}>
        <img className={s.thumb} src={this.state.thumb} />
        <table className={s.modelTable}>
          <tbody>
            <tr>
              <td>{i18n.t('components.model_context_menu.placing')} {this.state.name}</td>
            </tr>
            {commentRow}
          </tbody>
        </table>
      </span>
    );
  }
}

export default withStyles(s)(ModelContextMenu);
